export default __webpack_public_path__ + "static/media/logo-card-2048w.fea9f359.webp";